import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/undercut';
import { get, post, del } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getUndercutList({ payload }) {
  try {
    const response = yield call(
      get,
      `/cutting/by_semi?semiId=${payload.semiId}`
    );
    yield put(action.getUndercutListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getUndercutListFail());
  }
}

export function* getUndercutConfirmList({ payload }) {
  try {
    const response = yield call(
      get,
      `/cutting/for_confirm/list?dateFrom=${payload.dateFrom
        || ''}&dateTo=${payload.dateTo || ''}&plantId=${payload.plantId}`
    );
    yield put(action.getUndercutConfirmListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getUndercutConfirmListFail());
  }
}

export function* getUndercutOperation({ payload }) {
  try {
    const response = yield call(
      get,
      `/cutting/opeartion/get?semiId=${payload.semiId}`
    );
    yield put(action.getUndercutOperationSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getUndercutOperationFail());
  }
}

export function* getUndercutTypesList({ payload }) {
  try {
    const response = yield call(get, `/cutting/list?semiId=${payload.semiId}`);
    yield put(action.getUndercutTypesListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getUndercutTypesListFail());
  }
}

export function* saveUndercut({ payload }) {
  try {
    yield call(post, '/cutting/save', payload);
    yield put(action.saveUndercutSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.saveUndercutFail());
  }
}

export function* deleteUndercut({ payload }) {
  try {
    yield call(
      del,
      `/cutting/delete/by_semi?${payload.map((el) => `semiIds=${el}&`)}`,
      payload
    );
    yield put(action.deleteUndercutSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.deleteUndercutFail());
  }
}

export function* confirmUndercut({ payload }) {
  try {
    yield call(post, '/cutting/confirm', payload);
    yield put(action.confirmUndercutSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.confirmUndercutFail());
  }
}

export function* stornoUndercut({ payload }) {
  try {
    yield call(
      post,
      `/cutting/storno?comment=${payload.comment}`,
      payload.cuttingPieceIds
    );
    yield put(action.stornoUndercutSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.stornoUndercutFail());
  }
}
